import { render, staticRenderFns } from "./DraftNotificationPanel.vue?vue&type=template&id=6222376b&scoped=true"
import script from "./DraftNotificationPanel.vue?vue&type=script&lang=js"
export * from "./DraftNotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./DraftNotificationPanel.vue?vue&type=style&index=0&id=6222376b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222376b",
  null
  
)

export default component.exports